<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>接入配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.accessId" placeholder="接入id" class="handle-input mr10"></el-input>
				<el-input v-model="query.accessName" placeholder="名称" class="handle-input mr10"></el-input>
				<el-select v-model="query.accessType" placeholder="请选择接入类型">
					<el-option key="" label="请选择接入类型" value=""></el-option>
					<el-option key=0 label="客户端接入" :value=0></el-option>
					<el-option key=1 label="客户接入" :value=1></el-option>
				</el-select>
				&nbsp;
				&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key=0 label="启用" :value=0></el-option>
					<el-option key=1 label="停用" :value=1></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="accessId" label="接入ID"></el-table-column>
                <el-table-column prop="accessName" label="名称"></el-table-column>
				<el-table-column prop="accessType" label="接入类型">
					<template slot-scope="scope">
                        {{scope.row.accessType==0?"客户端接入":(scope.row.accessType==1?"第三方接入":"官网接入")}}
                    </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter = "statusFormat"></el-table-column>
				<el-table-column prop="userId" label="数据管理员" width = "160px" :formatter="userIdFormat"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="60%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model= "activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="接入ID" prop="accessId">
							<el-input v-model="form.accessId" :disabled="isDisabled"></el-input>
						</el-form-item>
						<el-form-item label="名称" prop="accessName">
							<el-input v-model="form.accessName"></el-input>
						</el-form-item>
						<el-form-item label="接入类型" prop="accessType">
							<el-select v-model="form.accessType" placeholder="请选择接入类型">
								<el-option key=0 label="客户端接入" :value=0></el-option>
								<el-option key=1 label="第三方接入" :value=1></el-option>
								<el-option key=2 label="官网接入" :value=2></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="字符串密钥" prop="secretKey">
							<el-input v-model="form.secretKey"></el-input>
						</el-form-item>
						<el-form-item label="加密协议" prop="accessName">
							<el-select v-model="form.encryptAgreement" placeholder="请选择加密协议">
								<el-option key="" label="请选择加密协议" value=""></el-option>
								<el-option key="RSA/ECB/PKCS1Padding" label="RSA/ECB/PKCS1Padding" value="RSA/ECB/PKCS1Padding"></el-option>
								<el-option key="RSA" label="RSA" value="RSA"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="签名协议" prop="accessName">
							<el-select v-model="form.signAgreement" placeholder="请选择签名协议">
								<el-option key="" label="请选择签名协议" value=""></el-option>
								<el-option key="SHA1WithRSA" label="SHA1WithRSA" value="SHA1WithRSA"></el-option>
								<el-option key="MD5withRSA" label="MD5withRSA" value="MD5withRSA"></el-option>
								<el-option key="SHA256withRSA" label="SHA256withRSA" value="SHA256withRSA"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="数据管理员" prop="userInfo">
							<el-cascader placeholder="请选择数据管理员"
								:options="options" :show-all-levels="false"
								v-model="form.userInfo" filterable clearable>
							</el-cascader>
						</el-form-item>
						<el-form-item label="状态" prop="status">
							<el-select v-model="form.status" placeholder="请选择状态">
								<el-option key="" label="请选择状态" value=""></el-option>
								<el-option key=0 label="启用" :value=0></el-option>
								<el-option key=1 label="停用" :value=1></el-option>
							</el-select>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="外部接入秘钥" name="foreignKeyTab">
						<el-form-item label="外部接入公钥" prop="foreignPublicKey">
							<el-input type=textarea :rows=8 v-model="form.foreignPublicKey"></el-input>
						</el-form-item>
						<el-form-item label="外部接入私钥" prop="foreignPrivateKey">
							<el-input type=textarea :rows=8 v-model="form.foreignPrivateKey"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="服务器秘钥" name="serverKeyTab">
						<el-form-item label="内部公钥" prop="serverPublicKey">
							<el-input type=textarea :rows=8 v-model="form.serverPublicKey"></el-input>
						</el-form-item>
						<el-form-item label="内部私钥" prop="serverPrivateKey">
							<el-input type=textarea :rows=8 v-model="form.serverPrivateKey"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="数据映射信息" name="mappingTab" v-if="form.accessType==1">
						<el-input type=textarea :rows=20 v-model="form.dataMapping"></el-input>
					</el-tab-pane>
					<el-tab-pane label="可用功能" name="funcTab" v-if="form.accessType==0">
						<el-checkbox-group v-model="funcCheckedList" style="margin:10px;">
							<el-checkbox label="采集"></el-checkbox>
							<el-checkbox label="发布"></el-checkbox>
							<el-checkbox label="动态"></el-checkbox>
							<el-checkbox label="营销"></el-checkbox>
							<el-checkbox label="工具"></el-checkbox>
							<el-checkbox label="调试"></el-checkbox>
						</el-checkbox-group>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { generateRandomString } from '../../../utils/common';
import { fetchAccessConfigData, saveAccessConfig, deleteAccessConfig, getAccessConfig, 
getDepartmentUserTree} from '../../../api/index';
export default {
    name: 'access-config',
    data() {
		
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
			enumValueKV:[],
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			activeName:"baseTab",
			rules: {
                accessId: [{ required: true, message: '接入ID不能为空', trigger: 'blur' }],
				accessName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
				accessType: [{ required: true,  message: '请选择接入类型', trigger: 'blur' }],
				secretKey: [{ required: true, message: '字符串密钥不能为空', trigger: 'blur' }],
				encryptAgreement: [{ required: true, message: '请寻找加密协议', trigger: 'blur' }],
				signAgreement: [{ required: true, message: '请选择签名协议', trigger: 'blur' }],
				userInfo: [{ required: true, message: '请选择数据管理员', trigger: 'blur' }],
				status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
			count:0,
			controll:{},
			options:[],
			departmentMapping:{},
			funcCheckedList: []
        };
    },
    created() {
		this.controll = getControll("access-config");
		this.getOperator();
        this.getData();
    },
    methods: {
		getOperator() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.options = res.data;
					this.getDepartmentMapping(res.data, undefined, undefined);
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
		getDepartmentMapping(nodes, parent, parentName) {
			for(let i = 0; i < nodes.length; i++) {
				let node = nodes[i];
				let mapping = {};
				let departmentInfo = [];
				let name = "";
				if (parent) {
					departmentInfo = departmentInfo.concat(parent);
					name = parentName;
				}
				departmentInfo.push(node.value);
				name = (name?name + "/":"") + node.label;
				mapping["name"] = name;
				mapping["info"] = departmentInfo;
				this.departmentMapping[node.value+"-"+(node.sign?node.sign:"")] = mapping;
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, departmentInfo, name);
				}
			}
		},
		userIdFormat(row, column, cellValue) {
			let mapping = this.departmentMapping[cellValue + "-1"];
			return mapping?mapping["name"]:cellValue;
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (cellValue == '0') {
				return '启用';
			} else {
				return '禁用';
			}
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchAccessConfigData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccessConfig([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccessConfig(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.funcCheckedList = ["采集","发布","动态","营销","工具","调试"];
			this.enumValueKV = [];
			this.isDisabled = false;
			this.activeName = "baseTab";
			this.title = "添加新纪录";
			this.$set(this.form, "accessId", generateRandomString(16));
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.isDisabled = true;
			this.activeName = "baseTab";
			this.title = "编辑";
			getAccessConfig(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (this.form.func) {
						this.funcCheckedList = this.form.func.split(",");
					}
					let mapping = this.departmentMapping[this.form["userId"] + "-1"]; 
					if (mapping) {
						this.$set(this.form, "userInfo", mapping["info"]);
					}
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.form.userInfo != undefined) {
						this.$set(this.form, "userId", this.form.userInfo[this.form.userInfo.length - 1]);
					}
					this.$set(this.form, "func", this.funcCheckedList.join(","));
					saveAccessConfig(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
